import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'
import CaAccordionSkeletonContainer from 'redux/containers/pages/currentawareness/CaAccordionSkeletonContainer'

const CaAccordionWrapper = (props) => {
  const { group } = props

  return (
    <ResponseConsumer
      response={(group || {}).status ? group.status : group}
      pendingComponent={CaAccordionSkeletonContainer}
      content={() => <CaAccordion {...props} />}
    />
  )
}

const CaAccordion = ({ aol, expandCallback, group, selectCallback }) => {
  const cxNames = {
    accordionContainer: 'mb6',
    groupHeader: {
      depthStyle: () => {
        return 'bg-white black b--dark-cerulean'
      },
      iconDepthStyle: depth => {
        switch (depth) {
          case 2:
            return 'white'
          default:
            return 'black o-80'
        }
      }
    },
    contentHeader: {
      borderColor: 'b--dark-cerulean',
      headerBackground: 'bg-ghost-grey'
    },
    content: {
      divider: 'bt--dark-cerulean'
    },
    borderColor: 'b--dark-cerulean'
  }

  return (
    <AccordionWrapperContainer
      {...{ aol, expandCallback, group, selectCallback, cxNames }}
      title={null}
      eventCategory='CA'
      showAllS1
      SectionHeaderOverride={() => null}
      styleTitle={false}
      contained
      legacyClassWrapper={false}
    />
  )
}

export default CaAccordionWrapper
